import { BuscarCautelasDisponiveisDto } from "@/dtos/BuscarCautelasDisponiveisDto";
import { api } from "./Api";
import { ApiResult } from "./ApiResult";
import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho";

interface BuscarQuantidadeCautelasCarrinhoDTO {
    QuantidadeCautelasReservadas: number
}



class CautelaService {
    async buscarCautelasDisponiveis() {
        let { data: result } = await api.get<ApiResult<BuscarCautelasDisponiveisDto>>("Cautela/BuscarCautelasDisponiveis");
        return result
    }

    async buscarCautelasDisponiveisPorDezenas(dezenas: string[]) {
        let { data: result } = await api.get<ApiResult<BuscarCautelasDisponiveisDto>>("Cautela/BuscarCautelasDisponiveis?dezenas=" + dezenas.join(';'));
        return result
    }

    async buscarCautelasAlocadas() {
        let { data: result } = await api.get<ApiResult<BuscarCautelasDisponiveisDto>>("Cautela/BuscarCautelasAlocadas");
        return result
    }

    async buscarNovasCautelasAlocadas() {
        let { data: result } = await api.get<ApiResult<BuscarCautelasDisponiveisDto>>("Cautela/BuscarNovasCautelasAlocadas");
        return result
    }

    async buscarCautelasAlocadasPorDezenas(dezenas: string[]) {
        let { data: result } = await api.get<ApiResult<BuscarCautelasDisponiveisDto>>("Cautela/BuscarCautelasAlocadas?dezenas=" + dezenas.join(';'));
        return result
    }

    async buscarQuantidadeCautelasCarrinho() {
        let { data: result } = await api.get<ApiResult<BuscarQuantidadeCautelasCarrinhoDTO>>("Cautela/BuscarQuantidadeCautelasCarrinho");
        return result
    }

    async buscarQtdSurpresinha() {
        let { data: result } = await api.get<ApiResult<number[]>>("Configuracao/BuscarQtdSurpresinha");
        return result
    }

    async adicionarCautelaCarrinho(idCautela: number) {
        let { data: result } = await api.post<ApiResult<null>>(`Cautela/AdicionarCautelaCarrinho/${idCautela}`);
        return result
    }

    async adicionarCautelasCarrinhoPorQtd(qtdCautelas: number) {
        let { data: result } = await api.post<ApiResult<number[]>>(`Cautela/AdicionarCautelaCarrinhoPorQtd/${qtdCautelas}`);
        return result
    }

    async adicionarCautelasCarrinhoPorIdsCautelas(idCautelas: number[]) {
        let { data: result } = await api.post<ApiResult<any>>(`Cautela/AdicionarCautelasCarrinho/`, idCautelas);
        return result
    }

    async removerCautelasCarrinho() {
        let { data: result } = await api.post<ApiResult<any>>(`Cautela/RemoverCautelasCarrinho/`);
        return result
    }

    async removerCautelaCarrinho(idCautela: number) {
        let { data: result } = await api.post<ApiResult<any>>(`Cautela/RemoverCautelaCarrinho/${idCautela}`);
        return result
    }

    async buscarCautelasCarrinho() {
        let { data: result } = await api.get<ApiResult<BuscarCautelasCarrinhoDto>>(`Cautela/BuscarCautelasCarrinho`);
        return result;
    }
}

//eslint-disable-next-line
export default new CautelaService();